import { DELETE_ALL_DEVICES, ADD_DEVICES } from './actiontypes';

export function deleteAllDevicesAction() {
  return {
    type: DELETE_ALL_DEVICES,
  };
}

export function addDevicesAction(devices) {
  return {
    type: ADD_DEVICES,
    devices,
  };
}
